import dayjs from "dayjs";
import { registerSessionReset } from '../../utils/sessionLifecycle';
import { firstNonBlankText } from './contactDisplayName';
export { chatDisplayName } from './contactDisplayName';

const STATUS_TO_UI = { open: 1, resolved: 2, pending: 3, expired: 4 };

function previewText(lastMessage) {
  if (lastMessage?.text) return lastMessage.text;
  return { image: "Photo", audio: "Voice message", video: "Video", document: "Document", sticker: "Sticker" }[lastMessage?.kind] || null;
}

function tagLabels(tags, fallback) {
  if (!Array.isArray(tags)) return fallback;
  return tags
    .map(tag => typeof tag === "object" && tag !== null ? (tag.name ?? tag.label) : tag)
    .filter(tag => typeof tag === "string" && tag.trim())
    .map(tag => tag.trim());
}

let projections = new WeakMap();
registerSessionReset(() => { projections = new WeakMap(); });
export function canonicalOnlyChat(conversation) {
  if (projections.has(conversation)) return projections.get(conversation);
  const identities = conversation.participant?.identities || {};
  const activityAt = conversation.last_activity_at || conversation.last_message?.occurred_at;
  const expiryAt = conversation.service_window?.expires_at;
  const projection = {
    id: conversation.id,
    conversationId: conversation.id,
    canonical_id: conversation.id,
    channel_account_id: conversation.channel_account_id || conversation.channel_account?.id || null,
    customer_name: firstNonBlankText(conversation.participant?.display_name, identities.phone, identities.username) || "Unknown",
    phone: identities.phone || "",
    username: identities.username || "",
    bsuid: identities.bsuid || "",
    ticket_status: STATUS_TO_UI[conversation.lifecycle_status] ?? null,
    isBlocked: Boolean(conversation.blocked),
    quarantine: conversation.quarantine ?? null,
    security_flags: conversation.security_flags ?? [],
    agent: conversation.assignment?.assigned_to?.display_name ?? null,
    provider_assignee: conversation.assignment?.provider_assignee ?? null,
    unread_count: conversation.viewer_state?.unread_count ?? 0,
    starred: Boolean(conversation.viewer_state?.starred),
    tags: tagLabels(conversation.tags, []),
    last_message: previewText(conversation.last_message),
    last_message_time: activityAt ? dayjs(activityAt) : null,
    expiry: expiryAt ? dayjs(expiryAt) : null,
    customer_id: conversation.business_context?.customer_id ?? null,
    query_activity: conversation.business_context?.query_activity ?? null,
    listNotes: [],
    _canonical: conversation,
    _canonicalOnly: true,
    agent_id: conversation.assignment?.assigned_to?.user_id ?? null,
    customer_type: conversation.business_context?.customer_type ?? null,
    profile_name: firstNonBlankText(conversation.business_context?.customer_name),
    foundMessageId: conversation.search_match?.message_id ?? null,
  };
  projections.set(conversation, projection);
  return projection;
}

